<template>
  <div v-if="errorPage">
    <br />
    <div class="alert alert-danger text-center">Ο Χρήστης δεν βρέθηκε!</div>
  </div>
  <div v-else>
    <div v-if="currentUser" class="container text-center col-lg-8">
      <b-card
        header="Επεξεργασία Χρήστη"
        header-border-variant="info"
        header-text-variant="info"
        header-class="h4"
      >
        <b-form v-if="!submitted" class="col-md-8 mx-auto">
          <b-form-group class="mb-1" label="'Ονομα Χρήστη (Username)" label-for="userName">
            <b-form-input
              type="text"
              class="form-control"
              id="userName"
              required
              v-model="currentUser.userName"
              name="userName"
              disabled
            />
          </b-form-group>
          <b-form-group class="mb-1" label-for="onoma">
            <template v-slot:label>
              <span>'Ονομα</span>&nbsp;<sup>*</sup>
            </template>
            <b-form-input
              type="text"
              class="form-control"
              id="onoma"
              required
              v-model="currentUser.onoma"
              name="onoma"
            />
          </b-form-group>
          <b-form-group class="mb-1" label-for="epwnymo">
            <template v-slot:label>
              <span>Επώνυμο</span>&nbsp;<sup>*</sup>
            </template>
            <b-form-input
              type="text"
              class="form-control"
              id="epwnymo"
              required
              v-model="currentUser.epwnymo"
              name="epwnymo"
            />
          </b-form-group>
          <div v-if="!isBidder">
            <b-form-group class="mb-1" label-for="amka">
              <template v-slot:label>
                <span>ΑΜΚΑ</span>&nbsp;<sup>*</sup>
              </template>
              <b-form-input
                type="text"
                class="form-control"
                id="amka"
                required
                v-model="currentUser.amka"
                placeholder="πχ 12345678901"
                name="amka"
              />
            </b-form-group>
            <b-form-group class="mb-1" label=" Στρατιωτικός Προσωπικός κωδικός" label-for="strkProsKwd">
              <b-form-input
                type="text"
                class="form-control"
                id="strkProsKwd"
                required
                v-model="currentUser.strkProsKwd"
                name="strkProsKwd"
              />
            </b-form-group>
            <b-form-group class="mb-1" label="Γραφείο" label-for="grafeio">
              <b-form-input
                type="text"
                class="form-control"
                id="grafeio"
                required
                v-model="currentUser.grafeio"
                name="grafeio"
              />
            </b-form-group>
          </div>
          <b-form-group class="mb-1" label-for="thl">
            <template v-slot:label>
              <span>Τηλέφωνο</span>&nbsp;<sup>*</sup>
            </template>
            <b-form-input
              type="text"
              class="form-control"
              id="thl"
              required
              v-model="currentUser.thl"
              placeholder="πχ 6999999999"
              name="thl"
            />
          </b-form-group>
          <b-form-group class="mb-1" label-for="email">
            <template v-slot:label>
              <span>Δ/νση ηλεκτρονικού ταχυδρομείου</span>&nbsp;<sup>*</sup>
            </template>
            <b-form-input
              type="text"
              class="form-control"
              id="email"
              required
              v-model="currentUser.email"
              placeholder="πχ. papadakis@gmail.com"
              name="email"
            />
          </b-form-group>

          <div v-if="isBidder">
            <b-form-group class="mb-1" label="Φυσικό Πρόσωπο-Εταιρία" label-for="etairKoinop">
              <b-form-input
                type="text"
                class="form-control"
                id="etairKoinop"
                required
                v-model="currentUser.bidder.etairKoinop"
                name="etairKoinop"
              />
            </b-form-group>

          <b-form-group class="mb-1" label-for="adt">
            <template v-slot:label>
              <span>ΑΔΤ</span>&nbsp;<sup>*</sup>
            </template>
            <b-form-input
              type="text"
              class="form-control"
              id="adt"
              required
              v-model="currentUser.bidder.adt"
              placeholder="πχ. ΑΑ123456 (ελληνικοί χαρακτήρες)"
              name="adt"
            />
          </b-form-group>

          <b-form-group class="mb-1" label-for="afm">
            <template v-slot:label>
              <span>ΑΦΜ</span>&nbsp;<sup>*</sup>
            </template>
            <b-form-input
              type="text"
              class="form-control"
              id="afm"
              required
              v-model="currentUser.bidder.afm"
              placeholder="πχ. 012345678"
              name="afm"
            />
          </b-form-group>

          <b-form-group class="mb-1" label-for="address">
            <template v-slot:label>
              <span>Διεύθυνση</span>&nbsp;<sup>*</sup>
            </template>
            <b-form-input
              type="text"
              class="form-control"
              id="address"
              required
              v-model="currentUser.bidder.address"
              placeholder="πχ. εθνικής αντιστάσεως 30"
              name="address"
            />
          </b-form-group>
          </div>

          <b-form-group
            class="mb-1"
            v-if="this.allKladoi && this.allKladoi.length> 0"
            label="Κλάδος:"
          >
            <v-select
              @input="changeKlados"
              placeholder="Επιλέξτε Έναν"
              v-model="selectedKlados"
              :options="allKladoi"
              label="kladosLek"
              :reduce="klados => klados.id"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  :required="!selectedKlados"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </b-form-group>

          <b-form-group class="mb-1" v-if="this.allOss && this.allOss.length> 0" label="'Οπλο/Σώμα:">
            <v-select
              placeholder="Επιλέξτε Ένα"
              v-model="selectedOs"
              :options="allOss"
              label="osLek"
              :reduce="os => os.id"
            >
              <template #search="{ attributes, events }">
                <input class="vs__search" :required="!selectedOs" v-bind="attributes" v-on="events" />
              </template>
            </v-select>
          </b-form-group>

          <b-form-group
            class="mb-1"
            v-if="this.allBathmoi && this.allBathmoi.length> 0"
            label="Βαθμός:"
          >
            <v-select
              placeholder="Επιλέξτε Έναν"
              v-model="selectedBathmos"
              :options="allBathmoi"
              label="bathGr"
              :reduce="bathmos => bathmos.id"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  :required="!selectedBathmos"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </b-form-group>
        </b-form>
        <b-button class="m-3 btn btn-sm btn-success" @click="updateUser">
          <font-awesome-icon icon="save" />&nbsp;Αποθήκευση
        </b-button>
        <b-button class="m-3 btn btn-sm" variant="danger" @click="showModal">
          <font-awesome-icon icon="trash-alt" />&nbsp;Διαγραφή
        </b-button>
        <b-modal ref="delete-user-modal" hide-footer title="Διαγραφή Χρήστη">
          <div class="d-block text-center">
            <h3>Έιστε σίγουρος ότι θέλετε να διαγράψετε τον χρήστη ?</h3>
          </div>
          <b-button class="mt-3" variant="outline-danger" block @click="cancelDeletion">Ακύρωση</b-button>
          <b-button class="mt-2" variant="outline-warning" block @click="deleteUser">Επιβεβαίωση</b-button>
        </b-modal>
        <div class="text-left" v-if="!submitted">
          <sup>*</sup>&nbsp;<span>Υποχρεωτικά πεδία</span>
        </div>
      </b-card>
    </div>

    <div v-else>
      <br />
      <p>Παρακαλώ περιμένετε...</p>
    </div>
  </div>
</template>


<script>
import UserService from '../services/user.service';
import toast from '../services/toast';

export default {
  name: 'edit-user',
  data() {
    return {
      errorPage: false,
      currentUser: null,
      isBidder: null,
      allKladoi: [],
      selectedKlados: null,
      allOss: [],
      selectedOs: null,
      allBathmoi: [],
      selectedBathmos: null,
      submitted: false
    };
  },
  methods: {
    getUser(id) {
      UserService.getUser(id)
        .then(response => {
          this.currentUser = response.data;
          this.isBidder = this.currentUser.rolos.rolosLek == 'ROLE_BIDDER';
          this.isBidder = this.isBidder && this.currentUser.bidder != null;

          if (this.isBidder == false) {
            if (this.currentUser.bathmos != null) {
              this.selectedKlados = this.currentUser.bathmos.kladosBathKwd.kladosBathKwd;
            } else if (this.currentUser.osKwd != null) {
              this.selectedKlados = this.currentUser.osKwd.kladosBathKwd.kladosBathKwd;
            } else {
              this.selectedKlados = null;
            }
            this.getFormData(this.selectedKlados, false);
            this.initForm();
          }
        })
        .catch(e => {
          this.errorPage = true;
          console.log(e);
        });
    },
    updateUser() {
      var data;
      if (!this.isBidder) {
        data = {
          userName: this.currentUser.userName,
          onoma: this.currentUser.onoma,
          epwnymo: this.currentUser.epwnymo,
          strkProsKwd: this.currentUser.strkProsKwd,
          amka: this.currentUser.amka,
          grafeio: this.currentUser.grafeio,
          thl: this.currentUser.thl,
          email: this.currentUser.email,
          selectedOs: this.selectedOs,
          selectedBathmos: this.selectedBathmos
        };
        UserService.updateUser(this.currentUser.id, data)
          .then(response => {
            console.log(response.data);
            toast.success('Ο χρήστης ενημερώθηκε επιτυχώς!');
          })
          .catch(e => {
            console.log(e);
          });
      } else {
        data = {
          userName: this.currentUser.userName,
          onoma: this.currentUser.onoma,
          epwnymo: this.currentUser.epwnymo,
          etairKoinop: this.currentUser.bidder.etairKoinop,
          adt: this.currentUser.bidder.adt,
          afm: this.currentUser.bidder.afm,
          address: this.currentUser.bidder.address,
          thl: this.currentUser.thl,
          email: this.currentUser.email
        };
        console.log(data)
        UserService.updateBidder(this.currentUser.bidder.id, data)
        .then(response => {
            console.log(response.data);
            toast.success('Ο χρήστης ενημερώθηκε επιτυχώς!');
        })
        .catch(e => {
          console.log(e);
        });
      }
    },
    deleteUser() {
      UserService.deleteUser(this.currentUser.id)
        .then(response => {
          toast.success('Ο χρήστης διαγράφηκε επιτυχώς!');
          this.$router.push('/users');
        })
        .catch(e => {
          console.log(e);
        });
    },
    changeKlados() {
      this.getFormData(this.selectedKlados, true);
    },
    initForm() {
      UserService.initUserForm()
        .then(response => {
          this.allKladoi = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getFormData(kladosId, reset) {
      if (kladosId != null && kladosId != undefined) {
        UserService.populateUserForm(kladosId)
          .then(response => {
            this.allOss = response.data.oss;
            this.allBathmoi = response.data.bathmoi;

            if (reset) {
              this.selectedBathmos = null;
              this.selectedOs = null;
            } else {
              this.selectedBathmos =
                this.currentUser.bathmos != null
                  ? this.currentUser.bathmos.id
                  : null;
              this.selectedOs =
                this.currentUser.osKwd != null
                  ? this.currentUser.osKwd.id
                  : null;
            }
          })
          .catch(e => {
            console.log(e);
          });
      }
    },
    showModal() {
      this.$refs['delete-user-modal'].show()
    },
    cancelDeletion() {
      this.$refs['delete-user-modal'].hide()
    },
  },
  mounted() {
    this.getUser(this.$route.params.id);
  }
};
</script>